export enum TypeQrLink {
  CONTROLE = "CONTROLE",
  OPE = "OPE",
  PHOTO = "PHOTO",
  SCAN = "SCAN",
}
